import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RelatedContactWidgetComponent } from "./containers/related-contacts.components";
import { RelatedContactSectionComponent } from './components/related-contact-section/related-contact-section.component';
import { RelatedContactItemComponent } from './components/related-contact-item/related-contact-item.component';
import { RelatedContactViewComponent } from "./components/related-contact-view/related-contact-view.component";
import { RelatedContactFieldComponent } from "./components/related-contact-field/related-contact-field.component";
import { RelatedContactStringValueComponent } from './components/related-contact-string-value/related-contact-string-value.component';
import { RelatedContactWidgetBodyComponent } from './components/related-contact-widget-body/related-contact-widget-body.component';
import { RelatedContactAnchorComponent } from './components/related-contact-anchor/related-contact-anchor.component';
import { DetailsItemComponent } from "./components/details-item/details-item.component";
import { CompositeDetailsModule } from "@feature/_app_modules/composite-details/composite-details.module";

@NgModule({
    declarations: [RelatedContactWidgetComponent, RelatedContactSectionComponent, RelatedContactItemComponent, RelatedContactViewComponent,RelatedContactFieldComponent, RelatedContactStringValueComponent, RelatedContactWidgetBodyComponent, RelatedContactAnchorComponent, DetailsItemComponent],
    providers: [
    ],
    imports: [
      CompositeDetailsModule,
      CommonModule,
      SharedModule,
    ],
    exports: [RelatedContactWidgetComponent, RelatedContactSectionComponent],
  })
  export class RelatedContactsModule {}
